module.exports = __webpack_public_path__ + "img/cta.2171101e.svg";